import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import * as SubscriptionInfo from "../../../subscription.info";

@Component({
  selector: "DatasetDetail",
  templateUrl: './dataset-detail.component.html',
  styleUrls: ['./dataset-detail.component.scss'],
})
export class DatasetDetail implements OnInit, OnDestroy  {

  @Input() camera: any;
  @Input() dataset: any;
  @Input() removeDevice: any;
  @Input() cloudKey: any;
  @Input() plan: any;
  @Input() user: any;
  @Input() hideSites: boolean = false;
  @Input() layout: string = 'list';
  public levels = SubscriptionInfo.Levels;
  public showStream: boolean = false;

  constructor() {}

  ngOnInit(){
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
  }

}
